"use client";

import * as React from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";

const SimpleCollapsible = ({
  title,
  defaultOpen = false,
  disabled = false,
  children,
}: {
  title: string;
  defaultOpen?: boolean;
  disabled?: boolean;
  children: React.ReactNode;
}) => {
  const [isOpen, setIsOpen] = React.useState(defaultOpen);
  const { t } = useTranslation();

  const handleManagePlan = () => {
    // Get the O'Dashboard portal URL from environment
    const portalUrl = import.meta.env.VITE_OSOLUTION_API || 'https://odashboard.app';
    // Get the license key from localStorage
    const licenseKey = localStorage.getItem('odash_license_key') || '';
    // Navigate to the manage plan page
    const managePlanUrl = `${portalUrl}/odash/manage-plan?key=${licenseKey}`;
    window.open(managePlanUrl, '_blank');
  };

  return (
    <Collapsible
      open={isOpen}
      onOpenChange={(open) =>
        disabled
          ? toast.error(
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', alignItems: 'flex-start' }}>
                <div>{t("editor.graphConfig.common.subscriptionRequired")}</div>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleManagePlan();
                  }}
                  style={{
                    padding: '8px 16px',
                    backgroundColor: '#000',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    fontWeight: '500',
                  }}
                >
                  {t("editor.navbar.managePlan")}
                </button>
              </div>,
              {
                style: {
                  maxWidth: '500px',
                },
              }
            )
          : setIsOpen(open)
      }
      className={
        disabled
          ? "w-full border-b py-2 opacity-50 cursor-not-allowed"
          : "w-full border-b py-2"
      }
    >
      <CollapsibleTrigger asChild>
        <div className="flex items-center justify-between py-2">
          <span>{title}</span>
          {isOpen ? (
            <ChevronUp className="h-4 w-4" />
          ) : (
            <ChevronDown className="h-4 w-4" />
          )}
        </div>
      </CollapsibleTrigger>
      <CollapsibleContent className="space-y-2 py-2">
        {children}
      </CollapsibleContent>
    </Collapsible>
  );
};

export default SimpleCollapsible;
